import { HsocV2Faqs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/hsoc/HsocV2Faqs';
import { useTrackSectionViewed } from '../../hooks/useTrackSectionViewed';
import { Screens } from '../../types/PublicNavItem';
import { TRACKING_SOURCES, trackClickedLink, trackFaqInteraction } from '../../utils/tracking';
import { jsx as _jsx } from "react/jsx-runtime";
export const HsocFaqsSection = () => {
  const sectionRef = useTrackSectionViewed(TRACKING_SOURCES.FAQ, Screens.FLEX_SEATS_AND_CREDITS);
  return /*#__PURE__*/_jsx("div", {
    ref: sectionRef,
    children: /*#__PURE__*/_jsx(HsocV2Faqs, {
      onLinkClick: props => trackClickedLink(Object.assign({}, props, {
        trackingSource: TRACKING_SOURCES.FAQ,
        screen: Screens.FLEX_SEATS_AND_CREDITS
      })),
      onFaqInteraction: trackFaqInteraction
    })
  });
};
export default HsocFaqsSection;